import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ReportSummary from "@/components/report-summary";
import type { ChatSession } from "@/types";
import { useReportContext } from "./context";

function latestSession(sessions: ChatSession[]): ChatSession | null {
  if (sessions.length === 0) return null;
  return [...sessions].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  )[0];
}

export default function PatientReportSummary() {
  const { token, link, good, attention, videoUrl, sessions } = useReportContext();
  const location = useLocation();
  const navigate = useNavigate();
  const skipInitialChatRedirect =
    (location.state as { skipInitialChatRedirect?: boolean } | null)
      ?.skipInitialChatRedirect === true;

  // Returning visitor with prior chats → jump straight to the latest session.
  // First-time visitors (access_count === 1) always see the summary.
  if (!skipInitialChatRedirect && link.access_count > 1) {
    const latest = latestSession(sessions);
    if (latest) {
      return <Navigate to={`/r/${token}/s/${latest.id}`} replace />;
    }
  }

  function startChat() {
    const latest = latestSession(sessions);
    navigate(`/r/${token}/s/${latest ? latest.id : "new"}`);
  }

  return (
    <ReportSummary
      good={good}
      attention={attention}
      videoUrl={videoUrl}
      onStartChat={startChat}
    />
  );
}
